// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3OnGW","row":"Node_row__2i7Bf","label":"Node_label__3h0-q","footer":"Node_footer__164If"};